import { defineStore } from 'pinia'
const useUserStore = defineStore('users', {
  state: (): any => ({
    userProjectDialogVisible: false, // 个人档案
    familyProjectDialogVisible: false, // 家族档案
    healthNumberDialogVisible: false, //健康档案
  }),
  actions: {
    handleOpenUserProjectDialog() {
      this.userProjectDialogVisible = true
    },
    handleCloseUserProjectDialog() {
      this.userProjectDialogVisible = false
    },
    handleOpenFamilyProjectDialog() {
      this.familyProjectDialogVisible = true
    },
    handleCloseFamilyProjectDialog() {
      this.familyProjectDialogVisible = false
    },
    handleOpenHealthNumberDialog() {
      this.healthNumberDialogVisible =true
    },
    handleCloseHealthNumberDialog() {
      this.healthNumberDialogVisible =false
    }
  }
})

export default useUserStore